import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoostApprovalQueueComponent } from './boost-approval-queue.component';
import { MaterialMdcModule } from 'src/app/shared/material-mdc.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { RequestCardModule } from './components/request-card/request-card.module';
import { MatBadgeModule } from '@angular/material/badge';



@NgModule({
  declarations: [BoostApprovalQueueComponent],
  imports: [
    CommonModule,
    MaterialMdcModule,
    SharedModule,
    RequestCardModule,
    MatBadgeModule
  ],
  exports: [BoostApprovalQueueComponent]
})
export class BoostApprovalQueueModule { }
